<template>
	<div class="header">
		<img class="logo" src="@/static/logo2.png" />
		<div class="nav pc-only">
			<router-link v-for="(item, index) in navList" replace :to="item.toUrl" :key="index"
				:class="$store.state.routerLocation == item.location ? 'on' : ''"
				@click.native="changeNav(item.location)">{{ item.name }}</router-link>
		</div>
		<div class="headerR pc-only">

			<div class="iconfont icon-xiazai" @click="$refs.downloadList.open()" v-if="$store.state.userInfo.role != 1">
				<span v-show="isDownloadHistory"></span>
			</div>

			<!-- <el-popover trigger="hover" placement="bottom">
				<div class="briefing">
					<div class="briefingT">
						<h3>下载中心</h3>
					</div>
					<div class="briefingC">
						<div class="li" v-for="(item, index) in downloadHistoryList" :key="index">
							<p>{{ item.title }}</p>
							<span>{{ item.title }}</span>
						</div>
						<noData :isShow="!downloadHistoryList.length" :imgWidth="150" :isShowStr="false"></noData>
					</div>
					<div class="more">
						<span @click="$refs.downloadList.open()">查看全部任务</span>
					</div>
				</div>

				<div class="iconfont icon-xiazai" slot="reference">
					<span v-show="isDownloadHistory"></span>
				</div>
			</el-popover> -->
			<div class="avatar"
				@click="$openUrl(`/${$store.state.userInfo.role == 1 ? 'student/personalCenter/settings?tabIndex=4' : 'teacher/personalCenter/adjunct?tabIndex=0'}`)">
				<div class="headerRImg"
					:style="`background-image: url(${$store.state.userInfo.headImg ? $store.state.userInfo.headImg : $store.state.userInfo.role == 1 ? require('@/static/student.png') : require('@/static/teacher.png')})`">
				</div>
				<span>{{ $store.state.userInfo.nickName ? $store.state.userInfo.nickName : $store.state.userInfo.role ?
					'学生' : '老师' }}</span>
			</div>
			<div class="exit" @click="exit">
				<i class="iconfont icon-log-out"></i>
				<abbr>退出登录</abbr>
			</div>
		</div>

		<!-- 移动端汉堡菜单按钮 -->
		<div class="mobile-menu-btn mobile-only" @click="toggleMobileMenu">
			<i class="iconfont icon-caidan"></i>
		</div>

		<!-- 移动端侧边导航 -->
		<div class="mobile-menu" :class="{ 'active': isMobileMenuOpen }">
			<!-- 移动端用户信息 -->
			<div class="mobile-header"
				@click="$openUrl(`/${$store.state.userInfo.role == 1 ? 'student/personalCenter/settings' : 'teacher/personalCenter/adjunct'}?tabIndex=0`); closeMobileMenu()">
				<div class="mobile-header-img"
					:style="`background-image: url(${$store.state.userInfo.headImg ? $store.state.userInfo.headImg : $store.state.userInfo.role == 1 ? require('@/static/student.png') : require('@/static/teacher.png')})`">
				</div>
				<p>{{ $store.state.userInfo.nickName ? $store.state.userInfo.nickName : $store.state.userInfo.role ?
					'学生'
					: '老师' }}
				</p>
			</div>

			<!-- 移动端导航列表 -->
			<div class="mobile-nav">
				<router-link v-for="(item, index) in navList" replace :to="item.toUrl" :key="index"
					:class="$store.state.routerLocation == item.location ? 'on' : ''"
					@click.native="handleMobileNavClick(item.location)">
					{{ item.name }}
				</router-link>
			</div>

			<div class="mobile-exit" @click.stop="exit(); closeMobileMenu()">
				<i class="iconfont icon-log-out"></i>
				<abbr>退出登录</abbr>
			</div>
		</div>

		<!-- 遮罩层 -->
		<div class="overlay" :class="{ 'active': isMobileMenuOpen }" @click="closeMobileMenu"></div>

		<downloadList ref="downloadList"></downloadList>
	</div>
</template>
<script>
import {
	mapState
} from "vuex";
import variables from "@/assets/variables.module.scss";

import downloadList from "@/components/downloadList";

export default {
	name: 'Header',
	components: {
		downloadList
	},
	computed: {
		...mapState(["settings"]),
		userInfo() {
			return this.$store.state.userInfo
		},
		variables() {
			return variables;
		},
		// 判断是否为移动端
		isMobile() {
			return window.innerWidth < 768;
		}
	},
	watch: {
		userInfo: {
			handler(newVal, oldVal) {
				this.initNavList()
			},
			deep: true,
			immediate: true
		}
	},
	data() {
		return {
			navList: [],
			isStudent: true,
			isMobileMenuOpen: false, // 移动端菜单是否打开
			resizeHandler: null,// 用于移除事件监听
			isDownloadHistory: false,
			downloadHistoryList: [],
			downloadTimer: null
		}
	},
	created() {
		this.initNavList();

		// 监听窗口大小变化
		this.resizeHandler = () => {
			// 窗口尺寸变化时，如果是PC端则关闭移动端菜单
			if (!this.isMobile && this.isMobileMenuOpen) {
				this.closeMobileMenu();
			}
		};
		window.addEventListener('resize', this.resizeHandler);

		this.getUserDownloadAlert()
		this.downloadTimer = setInterval(() => {
			this.getUserDownloadAlert()
		}, 5000)

	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resizeHandler);
		if (this.downloadTimer) {
			clearInterval(this.downloadTimer);
			this.downloadTimer = null;
		}
	},
	methods: {
		initNavList() {
			if (this.$getLocalStorage('vuex').userInfo && this.$getLocalStorage('vuex').userInfo.role == 1) {
				this.isStudent = true;
				this.navList = [{
					name: '课程',
					location: 'course',
					toUrl: '/student/course'
				},
				{
					name: '电子书',
					location: 'adjunct',
					toUrl: '/student/adjunct'
				},
				{
					name: '作业',
					location: 'homework',
					toUrl: '/student/homework'
				},
				{
					name: '考试',
					location: 'exam',
					toUrl: '/student/exam'
				}
				];
			} else {
				this.isStudent = false;

				const baseNav = [{
					name: '课程',
					location: 'course',
					toUrl: '/teacher/course'
				},
				{
					name: '电子书',
					location: 'adjunct',
					toUrl: '/teacher/adjunct'
				},
				{
					name: '试卷',
					location: 'testPaper',
					toUrl: '/teacher/testPaper'
				},
				{
					name: '题库',
					location: 'questionBank',
					toUrl: '/teacher/questionBank'
				},
				{
					name: '选苗',
					location: 'selectTalents',
					toUrl: '/teacher/selectTalents'
				},
				{
					name: '资源',
					location: 'resource',
					toUrl: '/teacher/resource'
				},
				{
					name: '看板',
					location: 'summary',
					toUrl: '/teacher/summary'
				},
				{
					name: 'AI',
					location: 'ai',
					toUrl: '/teacher/ai'
				},
					// {
					// 	name: '发现',
					// 	location: 'knowledgeDiscovery',
					// 	toUrl: '/knowledge-discovery'
					// }
				];

				// if (process.env.NODE_ENV !== 'production') {
				// 	baseNav.push({
				// 		name: '资源',
				// 		location: 'resource',
				// 		toUrl: '/teacher/resource'
				// 	});
				// }

				this.navList = baseNav;

			}
		},

		changeNav(location) {
			this.$store.commit('setStateBasic', {
				paramName: 'routerLocation',
				val: location
			})
		},

		handleMobileNavClick(location) {
			this.changeNav(location);
			this.closeMobileMenu();
		},

		toggleMobileMenu() {
			this.isMobileMenuOpen = !this.isMobileMenuOpen;
			// 阻止页面滚动
			document.body.style.overflow = this.isMobileMenuOpen ? 'hidden' : '';
		},

		// 关闭移动端菜单
		closeMobileMenu() {
			this.isMobileMenuOpen = false;
			document.body.style.overflow = '';
		},

		exit() {
			this.$messageBox({
				title: '退出系统',
				message: '退出系统后，您的相关操作记录不会被保存，您确认要 退出系统吗?',
				confirmText: '确认',
				cancelText: '取消',
				onConfirm: () => {
					localStorage.removeItem('token');
					if (this.downloadTimer) {
						clearInterval(this.downloadTimer);
						this.downloadTimer = null;
					}
					this.$openUrl('/');

					if (this.isMobile) {
						this.closeMobileMenu();
					}
				}
			})
		},

		getUserDownloadAlert() {
			this.$request.get('/userApi/getUserDownloadAlert', false).then(res => {
				if (res.data && res.succeeded) {
					this.isDownloadHistory = res.data
				}
			})
		}
	}
}
</script>
<style lang="scss" scoped>
@import '@/assets/variables.module.scss';

.header {
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	height: 52px;
	box-sizing: border-box;
	//overflow: hidden;
	padding: 12px 40px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	z-index: 99;
	box-shadow: 0 4px 16px 0 rgba(0, 0, 0, .08);
	backdrop-filter: blur(12px);
	background: #000125;

	.logo {
		width: 64px;
	}

	.nav {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		white-space: nowrap;
		line-height: 52px;

		a {
			font-size: 16px;
			margin: 0 1vw;
			color: #d3d3d3;
			transition: all 0.3s;
			padding: 0 2vw;
			position: relative;

			&:hover {
				color: #fff;
			}

			&.on {
				color: transparent;
				background: #282B4E;
				background-image: linear-gradient(0, #629EFF 43%, #00F6FF 50%);
				background-clip: text;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				font-weight: bold;

				&:before {
					position: absolute;
					content: '';
					inset: 0;
					background: rgb(175, 205, 255, 0.1);
					z-index: -1;
				}
			}
		}
	}

	.headerR {
		display: flex;
		align-items: center;
		color: #fff;

		.icon-xiazai {
			font-size: 18px;
			margin-right: 15px;
			position: relative;
			cursor: pointer;

			span {
				width: 3px;
				height: 3px;
				background: #F10104;
				position: absolute;
				top: 0;
				right: -2px;
				border-radius: 50%;
			}
		}

		.avatar {
			display: flex;
			align-items: center;
			cursor: pointer;

			.headerRImg {
				height: 22px;
				width: 22px;
				border-radius: 100%;
				overflow: hidden;
				margin-right: 10px;
				background-repeat: no-repeat;
				background-size: cover
			}
		}

		.exit {
			display: flex;
			align-items: center;
			margin-left: 25px;
			cursor: pointer;

			.icon-log-out {
				margin-right: 2px;
			}
		}
	}

	.icon-caidan {
		color: #fff;
		font-size: 24px;
		cursor: pointer;
	}
}

.mobile-menu {
	position: fixed;
	top: 0;
	right: 8px;
	background: #fff;
	border-radius: 8px;
	transform: translateY(52px);
	opacity: 0;
	pointer-events: none;
	transition: transform 0.3s ease-in-out;

	&.active {
		transform: translateY(60px);
		opacity: 1;
		z-index: 98;
		pointer-events: auto;
	}

	.mobile-header {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 15px 0 10px;

		.mobile-header-img {
			width: 35px;
			height: 35px;
			background-repeat: no-repeat;
			background-size: cover;
			margin-bottom: 10px;
		}

		p {
			font-size: 14px;
		}
	}

	.mobile-nav {
		text-align: center;
		min-width: 130px;

		a {
			display: block;
			color: #5A5A5A;
			padding: 12px 0;
			font-size: 14px;
			transition: all 0.3s;
			border-bottom: 1px solid #EBEEF6;

			&.on {
				font-weight: bold;
				background: #EBEEF6;
				border-bottom: 1px solid #EBEEF6;
			}
		}
	}

	.mobile-exit {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		color: #8C8C8C;
		padding: 12px 0;

		.icon-log-out {
			margin-right: 5px;
		}
	}
}

// 遮罩层
.overlay {
	position: fixed;
	top: 52px;
	left: 0;
	right: 0;
	height: calc(100vh - 52px);
	background: rgba(0, 0, 0, 0.5);
	z-index: 97;
	opacity: 0;
	visibility: hidden;
	transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;

	&.active {
		opacity: 1;
		visibility: visible;
	}
}

// 响应式控制
@media (max-width: 767px) {
	.pc-only {
		display: none !important;
	}

	.mobile-only {
		display: block !important;
	}

	.header {
		padding: 12px 15px;
		overflow: visible;
	}
}

@media (min-width: 768px) {
	.pc-only {
		display: flex !important;
	}

	.mobile-only {
		display: none !important;
	}
}

.briefing {
	min-width: 255px;

	::v-deep .briefingT {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 5px;
		border-bottom: 1px solid #EBEEF6;

		h3 {
			color: #333;
			font-size: 12px;
			margin-bottom: 5px;
		}
	}

	::v-deep .briefingC {
		padding: 10px 5px;
		display: flex;
		flex-direction: column;
		row-gap: 10px;

		.li {
			display: flex;
			align-items: center;
			font-size: 12px;

			p {
				flex: 1;
				margin-right: 10px;
			}

			span {
				color: #8C8C8C;
			}
		}
	}

	::v-deep .more {
		font-size: 12px;
		color: #0D68FF;
		text-align: center;

		span {
			cursor: pointer;
		}
	}
}
</style>